export default __webpack_public_path__ + "f79521b9d8aa21e02df851740362c8dc.jpg";